<div class="table-buttons-container mx-4 row d-flex flex-wrap justify-content-between">
    <button class="btn btn-success col-xs-12 icon-btn table-button" (click)="sendButtonInfo(btn)" [disabled]="configButton(btn)" *ngFor="let btn of buttonsConfig">
        <span>{{'table.buttons.' + this.action | translate}}</span> 
        <span class="material-icons">{{btn.icon}}</span>
    </button>
</div>